import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import AudioPlayer from "../QuestionPage/AudioPlayer";

import { useState, useEffect } from "react";
import MockNavigation from "./MockNavigation";

// Fetching Data from the API]

// End

// Page Html
export default function SpeakingInstructionPage() {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const [audioLink, setaudioLink] = useState("");

  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h1 className="text-2xl pt-3 font-bold text-gray-900 sm:text-3xl ml-1 text-center md:text-start">
          Speaking Instruction
        </h1>
        <p className="p-2">
          Some questions require you to first listen to an audio clip and then
          record your answer by speaking clearly into the microphone.
          <br></br>
          <div className="flex py-4">
            <span className="flex-1">
              <b>Listening: </b>The Current Status shows how long you have until
              the audio clip starts.
              <img
                className=" "
                width="400px"
                src="/image/speaking/1.jpg"
              ></img>
            </span>
            <span className="flex-1">
              A blue bar shows the progress of the audio clip. When it reaches
              the right hand side the audio, clip will stop playing.
              <div className="flex">
                <img
                  className=" flex-1 p-2"
                  width="300px"
                  src="/image/speaking/4.jpg"
                ></img>
                <img
                  className=" flex-1 p-2"
                  width="300px"
                  src="/image/speaking/5.jpg"
                ></img>
              </div>
            </span>
          </div>
          <br></br>
          <div className="flex">
            <span className="max-w-xl">
              <b>Speaking: </b>The Current Status shows how long you have until
              the microphone opens. Start speaking when the status changes to
              recording.
              <img
                className=" "
                width="400px"
                src="/image/speaking/3.jpg"
              ></img>
            </span>
            <span className="flex-1 pl-24">
              You must finish before the progress bar reaches the right hand
              side. If you remain silent for longer than 3 seconds, the
              recording will stop. You will not be able to re-record.
              <div className="flex">
                <img
                  className=" flex-1 p-2"
                  width="300px"
                  src="/image/speaking/6.jpg"
                ></img>
                <img
                  className=" flex-1 p-2"
                  width="300px"
                  src="/image/speaking/7.jpg"
                ></img>
              </div>
            </span>
          </div>
          <br></br>
        </p>
      </div>
    </div>
  );
}
